import Button from "@src/components/UIElements/Button";
import Modal from "@src/components/UIElements/Modal";
import { Image } from "@src/components/Image";
import React, { useEffect } from "react";
import styles from "./FreeTrialBottomSheet.module.scss";
import { useDispatch, useSelector } from "react-redux";
import * as actionCreator from "../../store/actions";
import { useTranslation } from "react-i18next";
import { getCourseDetailsAction } from "@src/components/Tabs/Overview/store/actions";
import { quitWebviewDeeplink } from "@src/utils/goBack";
import { postEnableTrialCourse } from "../../../Tabs/Overview/store/services";
import toast from "react-hot-toast";
import { useRouter } from "@src/lib/router";
import { TAB_BAR_ENUMS } from "../../../UIElements/TabBar/store/constants";
import { getTabListAction } from "../../../UIElements/TabBar/store/actions";
import { newWebEngage } from "@src/utils/webEngageEvent";
import { EVENTS_NAME_MAPPING } from "@src/utils/constants";

const FreeTrialBottomSheet = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const dispatch = useDispatch();
  const state = useSelector(
    (state) => state?.bottomSheetReducer?.showFreeTrialBottomSheetAction
  );

  const courseId = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.metaData?.id
  );
  const isFreeTrialBottomSheetOpenViaTabSwitch = useSelector(
    (state) => state?.bottomSheetReducer?.isFreeTrialBottomSheetOpenViaTabSwitch
  );
  const userDetails = useSelector(
    (state) => state?.overviewReducer?.userDetails?.responseData?.user
  );
  const orgDetails = useSelector(
    (state) => state?.persistedDataReducer?.orgDetails?.organization
  );
  const handleStartTrial = async () => {
    try {
      const response = await postEnableTrialCourse({courseId})
      if(response?.data?.status === "success"){
        dispatch(actionCreator.showFreeTrialBottomSheetAction(false));
        dispatch(getTabListAction({ courseId, skipLoader: true}))
        toast.success("Trial enabled successfully")
        router.push(`/${router?.query?.courseId}/${TAB_BAR_ENUMS.trialContent}`)

        newWebEngage(EVENTS_NAME_MAPPING.freeTrialContent, {
          org_id: orgDetails?.id + "",
          cp_user_id: Number(userDetails?.id),
          date_and_time: new Date(),
        });
      }
    } catch (error) {
      console.log(error.message)
      toast.error("Something went wrong, Please try again")
    }
  }

  function handleGoBackInstead(){
    if(isFreeTrialBottomSheetOpenViaTabSwitch){
      dispatch(actionCreator.showFreeTrialBottomSheetAction(false));
    }else{
      quitWebviewDeeplink();
    }
    
  }
  
  useEffect(() => {
    return () => dispatch(actionCreator.setFreeTrialBottomsheetOpenViaTabSwitch(false))
  },[])
  return (
    <Modal
      showModal={state}
      handleClose={() => {
        dispatch(
          getCourseDetailsAction({
            courseId: courseId,
            isLoading: false,
          })
        );
        dispatch(actionCreator.showFreeTrialBottomSheetAction(false));
      }}
      isCloseButtonVisible={false}
    >
      <div className={styles.FreeTrial}>
        <div className={styles.FreeTrial__image}>
          <Image
            src={"https://cdn-wl-assets.classplus.co/frontend-assets/exclamation-mark.svg"}
            alt={t(
              "components.bottomSheets.components.freeTrialBottomSheet.rupeeIcon",
              "RupeeIcon"
            )}
            width="64px"
            height="64px"
          />
        </div>
        <h1 className={styles.FreeTrial__heading}>
          {t(
            "components.bottomSheets.components.freeTrialBottomSheet.notSureAboutTheCourse",
            "Not sure about the course?"
          )}
          <br/>
          {t(
            "components.bottomSheets.components.freeTrialBottomSheet.takeATrialThenBuy",
            "Take a trial then Buy"
          )}
        </h1>
        <p className={styles.FreeTrial__subtext}>
          {
          t(
            "components.bottomSheets.components.freeTrialBottomSheet.unlockedFro1day",
            "All the content will be unlocked for 1 day for trial"
          )}
        </p>
        <Button
          onClick={handleStartTrial}
        >
          {t(
            "components.bottomSheets.components.freeTrialBottomSheet.startFreeTrail",
            "Start TRIAL for FREE"
          )}
        </Button>
        <p className={styles.FreeTrial__goBackInsteadBtn} onClick={handleGoBackInstead}>
          {t(
            "components.bottomSheets.components.freeTrialBottomSheet.goBackInstead",
            "Go back instead"
          )}
        </p>
      </div>
    </Modal>
  );
};

export default FreeTrialBottomSheet;
